import { render, staticRenderFns } from "./SocialMediaPostsTab.vue?vue&type=template&id=474459eb&scoped=true"
import script from "./SocialMediaPostsTab.vue?vue&type=script&lang=js"
export * from "./SocialMediaPostsTab.vue?vue&type=script&lang=js"
import style0 from "./SocialMediaPostsTab.vue?vue&type=style&index=0&id=474459eb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474459eb",
  null
  
)

export default component.exports